module.exports = __webpack_public_path__ + "img/site.d715a7d5.svg";